import React from 'react';

const paths = {
  play: <path d="M8 5.5v13l11-6.5-11-6.5Z" fill="currentColor" stroke="none" />,
  pause: (
    <>
      <path d="M9 5v14M15 5v14" />
    </>
  ),
  reset: (
    <>
      <path d="M4.5 9a8 8 0 1 1-.4 5.2" />
      <path d="M4 4.5V9h4.5" />
    </>
  ),
  step: (
    <>
      <path d="M6 5.5v13l9-5.5-9-7.5Z" fill="currentColor" stroke="none" />
      <path d="M18 5v14" />
    </>
  ),
  download: (
    <>
      <path d="M12 3.5v11" />
      <path d="m7.5 10 4.5 4.5 4.5-4.5" />
      <path d="M4.5 19.5h15" />
    </>
  ),
  sparkles: (
    <>
      <path d="m12 3 1.4 4.1L17.5 8.5l-4.1 1.4L12 14l-1.4-4.1-4.1-1.4 4.1-1.4L12 3Z" />
      <path d="m18.5 13.5.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z" />
      <path d="m5 14 .7 1.8 1.8.7-1.8.7L5 19l-.7-1.8-1.8-.7 1.8-.7L5 14Z" />
    </>
  ),
  flask: (
    <>
      <path d="M9 3h6M10 3v5.2L5.6 17a2.4 2.4 0 0 0 2.1 3.5h8.6a2.4 2.4 0 0 0 2.1-3.5L14 8.2V3" />
      <path d="M7.5 14h9" />
    </>
  ),
  chevron: <path d="m8 10 4 4 4-4" />,
  chevronRight: <path d="m10 8 4 4-4 4" />,
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  alert: (
    <>
      <path d="M12 4 3.5 19h17L12 4Z" />
      <path d="M12 9v4.5M12 16.8v.2" />
    </>
  ),
  x: <path d="m6 6 12 12M18 6 6 18" />,
  maximize: (
    <>
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </>
  ),
  minimize: (
    <>
      <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" />
    </>
  ),
  sliders: (
    <>
      <path d="M4 7h6M14 7h6M4 17h10M18 17h2" />
      <circle cx="12" cy="7" r="2" />
      <circle cx="16" cy="17" r="2" />
    </>
  ),
  chart: (
    <>
      <path d="M4 20V5M4 20h16" />
      <path d="m7.5 15 4-4 3 2.5L19 8" />
    </>
  ),
  file: (
    <>
      <path d="M6 3.5h8l4 4V20.5H6V3.5Z" />
      <path d="M14 3.5v4h4M9 12h6M9 16h6" />
    </>
  ),
  shield: (
    <>
      <path d="m12 3 7 2.8v5.4c0 4.3-2.9 7.7-7 9.8-4.1-2.1-7-5.5-7-9.8V5.8L12 3Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  book: (
    <>
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5v-16Z" />
      <path d="M4 18.5A2.5 2.5 0 0 1 6.5 16H20" />
    </>
  ),
  activity: <path d="M3 12h4l2.5-6 5 12 2.5-6H21" />,
  cpu: (
    <>
      <rect x="7" y="7" width="10" height="10" rx="2" />
      <path d="M10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4" />
    </>
  ),
  terminal: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="m7 9 3 3-3 3M13 15h4" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16M9 7V4h6v3M6.5 7l1 13h9l1-13" />
      <path d="M10 11v5M14 11v5" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 12a8 8 0 1 1-2.6-5.9" />
      <path d="M20 4v5h-5" />
    </>
  ),
  eye: (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  grid: (
    <>
      <rect x="4" y="4" width="6" height="6" rx="1" />
      <rect x="14" y="4" width="6" height="6" rx="1" />
      <rect x="4" y="14" width="6" height="6" rx="1" />
      <rect x="14" y="14" width="6" height="6" rx="1" />
    </>
  ),
  arrowRight: <path d="M4 12h15M14 7l5 5-5 5" />,
  arrowLeft: <path d="M20 12H5M10 7l-5 5 5 5" />,
  expand: <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />,
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 7.5v.2" />
    </>
  ),
  bolt: <path d="M13 3 5 14h6l-1 7 8-11h-6l1-7Z" />,
  library: (
    <>
      <path d="M4 4h4v16H4zM10 4h4v16h-4z" />
      <path d="m16.5 5 3.5-.8 2.5 15-3.5.8-2.5-15Z" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  copy: (
    <>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-10A1.5 1.5 0 0 0 3 5.5v10A1.5 1.5 0 0 0 4.5 17H8" />
    </>
  ),
};

export function Icon({ name, size = 18, className = '', strokeWidth = 1.7, ...rest }) {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {content}
    </svg>
  );
}

export function BrandMark({ size = 42 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className="brand-mark" aria-hidden="true">
      <defs>
        <linearGradient id="brandGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--accent)" />
          <stop offset="100%" stopColor="#38bdf8" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="17" fill="rgba(8,19,31,.7)" stroke="rgba(255,255,255,.08)" />
      <circle cx="32" cy="32" r="18.5" fill="none" stroke="url(#brandGradient)" strokeWidth="2" opacity=".9" />
      <ellipse
        cx="32"
        cy="32"
        rx="18.5"
        ry="7"
        fill="none"
        stroke="url(#brandGradient)"
        strokeWidth="1.6"
        opacity=".7"
        transform="rotate(-28 32 32)"
      />
      <circle cx="32" cy="32" r="4" fill="url(#brandGradient)" />
      <circle cx="48.5" cy="24" r="2.8" fill="var(--accent)" />
    </svg>
  );
}

export function ExperimentGlyph({ id, size = 30 }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 32 32',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };
  if (id === 'pendulum') {
    return (
      <svg {...common}>
        <path d="M5 7h22" />
        <path d="M16 7v4" />
        <path d="M16 11c6.5 2.8 9.2 10.2 5.2 14.2" opacity=".35" strokeDasharray="2 3" />
        <path d="m16 11 7.8 12.8" />
        <circle cx="25.3" cy="26" r="3.2" fill="currentColor" stroke="none" />
        <path d="M16 11v3" opacity=".4" />
      </svg>
    );
  }
  if (id === 'collision') {
    return (
      <svg {...common}>
        <path d="M3 18h26" />
        <rect x="5" y="10" width="8" height="6" rx="1.5" fill="currentColor" stroke="none" opacity=".9" />
        <rect x="19" y="12" width="8" height="5" rx="1.5" fill="currentColor" stroke="none" opacity=".55" />
        <path d="M13 8h6M16.5 5.5 19 8l-2.5 2.5" />
        <path d="M8 23h4M20 23h4" opacity=".4" />
      </svg>
    );
  }
  if (id === 'incline') {
    return (
      <svg {...common}>
        <path d="M4 25h24L10 8 4 25Z" fill="currentColor" fillOpacity=".09" />
        <path d="M4 25h24L10 8" />
        <rect x="15.5" y="13.5" width="6" height="6" rx="1" transform="rotate(39 18.5 16.5)" fill="currentColor" stroke="none" />
        <path d="M11 25a7 7 0 0 1 2.2-4.2" opacity=".5" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <circle cx="16" cy="16" r="11" opacity=".45" />
      <circle cx="16" cy="16" r="6.5" opacity=".2" />
      <path d="M16 5v5M16 22v5M5 16h5M22 16h5" opacity=".35" />
      <circle cx="22.3" cy="9.7" r="3" fill="currentColor" stroke="none" />
      <path d="m22.3 9.7 3.2 6.1" />
      <path d="M16 16h6.3" opacity=".5" strokeDasharray="2 2" />
    </svg>
  );
}
